import { Component, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DateTimeAdapter, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import { Subscription } from 'rxjs';

// components
import { ReportComponent } from '../../shared/components/reporting/report.component';

// models
import { ApplicationSettings } from '../../shared/models/application-settings';

// services
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../shared/services/auth.service';
import { ErrorService } from '../../shared/services/error.service';
import { LanguageService } from '../../shared/services/language.service';;
import { SpinnerService } from '../../shared/services/spinner.service';
import { TitleService } from '../../shared/services/title.service';
import { WebApiService } from '../../shared/services/web-api.service';

import { BuyerService } from '../../shared/services/buyer.service';

const NOON = 12;

@Component({
  selector: 'report-editor.component',
  templateUrl: 'report-editor.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['report-editor.component.scss'],
  providers: [{ provide: DateTimeAdapter, useClass: MomentDateTimeAdapter }, { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-GB' }]
})

export class ReportEditorComponent extends ReportComponent implements OnDestroy {
  @ViewChild('filterForm') filterForm: NgForm;

  buyerId: number;
  lang = 'nl-be';

  rtlEnabled = localStorage.getItem('last-selected-language-direction') ? JSON.parse(localStorage.getItem('last-selected-language-direction')) : false;
  private _subscription: Subscription;

  constructor(
    appSettings: ApplicationSettings,
    route: ActivatedRoute,
    titleService: TitleService,
    languageService: LanguageService,
    router: Router,
    errorService: ErrorService,
    buyerService: BuyerService,
    spinner: SpinnerService,
    translateService: TranslateService,
    dateTimeAdapter: DateTimeAdapter<any>,
    webApiService: WebApiService,
    authenticationService: AuthService)
  {
    super(appSettings, route, titleService, languageService, router, errorService, buyerService, spinner, translateService, dateTimeAdapter, webApiService, authenticationService);
    route.params.subscribe(val => {
      this.init();
    });
    this.lang = this.translateService.currentLang;
    this._subscription = this.languageService.direction.subscribe(dir => {
      this.rtlEnabled = dir;
    });
  }

  init()
  {
    this.buyerId = +this.route.snapshot.params['id'];

    super.init();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  SpecificHandlingAfterFetchingServices():void
  {
  }

  getFilterForServerFixedFiltering(filterForServer) {
  }

  getBuyerId() {
    return this.buyerId;
  }

  navigate(report){
    this.router.navigate(['/buyer/reports/' + this.buyerId + '/ac/' + this.auctionClusterId + '/report/' + report.reportId]);
  }
}
